import { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useNetworkState } from 'react-use';

const TOAST_ID = 'network-status';
const PROBE_INTERVAL = 5000;

// Chrome on Android (incl. our TWA shell) can leave navigator.onLine stuck at
// false after a VPN is turned on/off while the network actually works, so the
// browser's signal is only a hint: confirm with a real request before warning.
const isReachable = async () => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 4000);
  try {
    await fetch(`/favicon.ico?_=${Date.now()}`, { method: 'HEAD', cache: 'no-store', signal: controller.signal });
    return true;
  } catch {
    return false;
  } finally {
    clearTimeout(timeout);
  }
};

export const useNetworkStatus = () => {
  const { online } = useNetworkState();

  useEffect(() => {
    if (online) {
      toast.dismiss(TOAST_ID);
      return;
    }

    let cancelled = false;
    let timer: ReturnType<typeof setTimeout>;
    const check = async () => {
      const reachable = await isReachable();
      if (cancelled) return;
      if (reachable) {
        toast.dismiss(TOAST_ID);
      } else {
        toast.loading('ارتباط شما با اینترنت قطع شده است.', {
          id: TOAST_ID,
          duration: Infinity,
          position: 'top-center',
          className: '!bg-slate-900 !text-white',
        });
      }
      // Back off once the network is confirmed working despite the stuck flag.
      timer = setTimeout(check, reachable ? PROBE_INTERVAL * 6 : PROBE_INTERVAL);
    };
    check();

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [online]);
};
